<div class="product-detail-info-background intro-background"
     [ngStyle]="{ 'background-image': 'url(' + backgroundImageUrl + ')'}">
  <div class="product-detail-info-body">
    <div class="left" [ngClass]="{'play-left': play}">
      <h3 class="product-detail-info-title" [translate]="titleKey"></h3>
      <div class="product-detail-info-text intro-text" [innerHTML]= "descriptionKey | translate"></div>
      <app-order-button [x]="0"
                        [y]="0"
                        [ownerComponent]="componentName"
                        [pack]="pack"
                        [superiorSubscribedPack]="superiorSubscribedPack"
                        (emitOnBack)="onBack()"
                        [isPlayAndInfoPage]="true"
                        (emitOnEnterPressed)="onEmitOrderProduct($event)">
      </app-order-button>
    </div>
    <div class="right" *ngIf="columns2">
      <img class="product-detail-channels-image" src="{{bannerImageUrl}}"/>
    </div>
  </div>
</div>
